import React from 'react';
import {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import axiosServise from '../ApiService';
import './HolyQuranStyle.scss';
import quranBackdrop from '../../assets/images/quranBackdrop.svg';
import {SurahQuranData} from './SurahQuranData';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

export default function QuranPage() {
    let QuranInfo = SurahQuranData;

    const [quranValue, setQuranValue] = useState([]);
    const [sureName, setsureName] = useState('');
    const {id} = useParams();
    const countOfSurahID = parseInt(id)
    const [isLoading, setIsLoading] = useState(false);

    const inTheNameOfGod = {
        'arabicText': "بِسْمِ اللّهِ الرَّحْمنِ الرَّحيمِ ",
        'persianText': "به نام خداوند بخشنده و مهربان",
    }


    useEffect(() => {
        setIsLoading(true);
        getData()
        //for find sureName
        const findSureName = QuranInfo.find((item) => item.countOfSurah === countOfSurahID)
        setsureName(findSureName.nameOfSurah)
    }, [setQuranValue, setsureName])

    const getData = () => {
        axiosServise.get(`Quran/BySurah/${id}`).then(response => {
            const data = response.data.content;
            setQuranValue(data)
            setIsLoading(false)
        }).catch(error => {

        });
    }

    return (<>
        <div className='third-base pt-md-5' style={{paddingBottom: '60px'}}>
            {/*<div className='player-container col-12'>*/}
            {/*    <AudioPlayer className='col-11 col-md-5'*/}
            {/*                 src="http://khorshidpishva.com:8080/api/FileManager/GetAlFatihaAudio/"*/}
            {/*                 onPlay={e => console.log("onPlay")}*/}
            {/*    />*/}
            {/*</div>*/}
            <div className='HolyQuranPage col-11 col-md-9'>
                <div className='section-header col-12 col-md-7 m-auto mb-3'>
                    <div className='nameOfSure col-12'>
                        <div>
                            <img src={quranBackdrop} alt=""/>
                        </div>
                        <h3 style={{fontFamily: 'QuranTaha'}}>{sureName}</h3>
                    </div>
                </div>
                <div className='QuranPage-container'>
                    <div className='verse'>
                        <div className='container-Quranpage'>
                            {
                                sureName === 'حمد' || sureName === 'توبه' ? <div></div>
                                    : <div className='in-the-name-of-god-verse col-12'>
                                        <div className='col-11'>
                                            <div className='arabic-text' style={{textAlign: 'center'}}>
                                                <span>{inTheNameOfGod.arabicText}</span>
                                            </div>
                                            <div className='persian-text' style={{textAlign: 'center'}}>
                                                <p>{inTheNameOfGod.persianText}</p>
                                            </div>
                                        </div>
                                    </div>
                            }
                            {
                                quranValue.map((item) => {
                                    return (<div
                                        className={`verse-container col-12 ${item.verse % 2 === 0 ? "glass-effect" : ""}`}
                                        key={item.id}>
                                        <div className='section-right-text col-11'>
                                            <div className='arabic-text'>
                                                <span>{item.arabicText}</span>
                                            </div>
                                            <div className='persian-text'>
                                                <p>{item.persianText}</p>
                                            </div>
                                        </div>
                                        <div className='section-left-number-more col-1'>

                                            <div className='numberOf-sure col-12 col-md-6 d-flex'>
                                                <div className='verse-number-icon'>
                                                    {item.verse}
                                                </div>
                                            </div>

                                            <div className='more-option-sure'>


                                            </div>
                                        </div>
                                    </div>)
                                })}

                        </div>
                    </div>
                </div>
            </div>


        </div>
    </>)
};

